(function () {
	'use strict';
	document.addEventListener( 'DOMContentLoaded', () => {
		const navLinks 				= document.querySelectorAll( 'nav.is-anchor-navigation li' );
		const anchorNav				= document.querySelector( 'nav.is-anchor-navigation' );
		const siteHeader 			= document.querySelector( '.site-header' );
		const promoBanner 			= document.querySelector( '.wp-block-colibri-promo' );
		const promoBannerCloseBtn   = promoBanner?.querySelector( '.promo-inner .close' );
		const deliveryFilterPanel   = document.querySelector( '.filter-panel[data-name="delivery_method_id"]' );
		const deliveryFilterInputs  = deliveryFilterPanel ? deliveryFilterPanel.querySelectorAll( 'input.custom-control-input' ) : [];

		// Early exit if there's no anchor navigation
		if ( ! anchorNav ) return;

		function getTopOffset() {
			let topOffset = 0;

			topOffset += getStickyOffset( siteHeader );
			topOffset += getStickyOffset( promoBanner );

			return topOffset;
		}

		function getStickyOffset( element ) {
			if ( ! element ) return 0;

			const position = window.getComputedStyle( element ).position;
			return ( position === 'sticky' || position === 'fixed' ) ? element.offsetHeight : 0;
		}

		function updateStickyTop() {
			const offset = getTopOffset();
			anchorNav.style.top = `${ offset }px`;
		}

		function setScrollMargin() {
			const navHeight = anchorNav.offsetHeight;
			const navTopOffset = parseInt( getComputedStyle( anchorNav ).top || 0, 10 );
			const totalOffset = navTopOffset + navHeight + 24;

			navLinks.forEach( link => {
				const anchor = link.querySelector( 'a' );
				if ( anchor ) {
					const href = anchor.getAttribute( 'href' );
					if ( href && href.startsWith( '#' ) && href.length > 1 ) {
						try {
							const section = document.querySelector( href );
							if ( section ) {
								section.style.scrollMarginTop = `${totalOffset}px`;
								section.classList.add( 'no-focus-outline' );
							}
						} catch ( error ) {
							console.warn( `Invalid selector: ${href}`, error );
						}
					}
				}
			} );
		}

		function updateHashAndNotify(target, useReplace = true) {
			if (useReplace) {
				history.replaceState(null, '', `${window.location.pathname}${window.location.search}${target}`);
			} else {
				history.pushState(null, '', `${window.location.pathname}${target}`);
			}
			// Manually notify listeners expecting 'hashchange'
			window.dispatchEvent(new HashChangeEvent('hashchange'));
		}

		function smoothScrollTo( target ) {

			let section = null;
			let isTabTarget = false;

			try {
				section = document.querySelector( target );
			} catch ( e ) {
				// invalid selector, ignore — we’ll try data-anchor
			}
			if ( !section ) {
				const value = target.startsWith( '#' ) ? target.slice( 1 ) : target;
				try {
					section = document.querySelector( `[data-anchor="${CSS.escape( value )}"]` );
					isTabTarget = !!section;
				} catch ( e ) {
				}
			}
			if ( !section ) return;

			// Update URL hash and notify listeners (works for both ID and data-anchor cases)
			updateHashAndNotify( target, /* useReplace: */ true );

			if ( !isTabTarget ) {
				section.scrollIntoView( { behavior: 'smooth', block: 'start' } );
			} else {
				const rect = section.getBoundingClientRect();
				const absoluteTop = rect.top + window.pageYOffset;
				const scrollTarget = absoluteTop - 200; //offset by 200px

				window.scrollTo( {
					top: scrollTarget,
					behavior: 'smooth'
				} );
			}
		}

		function handleNavClick( anchorHref, clickedLink ) {

			navLinks.forEach( nav => nav.classList.remove( 'active' ) );

			clickedLink.closest( 'li' )?.classList.add( 'active' );

			const [ sectionId, filterValue ] = anchorHref.split( '_' );

			if ( filterValue && deliveryFilterInputs && deliveryFilterInputs.length ) {
				const resetBtn = document.querySelector( '.js-reset-filters' );
				if ( resetBtn ) resetBtn.click();
				if ( sectionId) smoothScrollTo( sectionId );

				setTimeout( () => {
					const match = [ ...deliveryFilterInputs ].find(
						inp => ( inp.value || '' ).toLowerCase() === filterValue.toLowerCase()
					);
					if ( !match ) return;

					match.click();

					history.replaceState( null, '', window.location.pathname + window.location.search );
				}, 400 );
			} else {
				const resetBtn = document.querySelector( '.js-reset-filters' );
				if ( resetBtn ) resetBtn.click();

				history.replaceState( null, '', `${window.location.pathname}${anchorHref}` );
				smoothScrollTo( anchorHref );
			}
		}

		function updatePromoBannerTop() {
			if ( ! promoBanner ) return;

			let topOffset = 0;

			topOffset += getStickyOffset( siteHeader );

			promoBanner.style.top = `${ topOffset }px`;
		}

		function setActiveOnLoad( hash ) {
			const deliveryId = new URLSearchParams( window.location.search ).get( 'delivery_method_id' );

			// Exit early if there's no hash and no delivery ID in URL
			if ( !hash && !deliveryId ) return;

			let filterValue = null;
			if ( deliveryId && deliveryFilterInputs && deliveryFilterInputs.length ) {
				const match = [ ...deliveryFilterInputs ].find( inp => ( inp.dataset.ids || '' ).split( '!' )[ 0 ] === deliveryId );
				if ( match ) filterValue = ( match.value || '' ).toLowerCase();
			}

			let target = null;
			if ( hash && hash.startsWith( '#' ) ) {
				target = document.querySelector( hash );
			}

			navLinks.forEach( li => {
				const anchor = li.querySelector( 'a' );
				if ( ! anchor ) return;

				const href = ( anchor.getAttribute( 'href' ) || '' );
				const isHashMatch = !!hash && href === hash;
				const isParamMatch = !!filterValue && href.toLowerCase().includes( filterValue );

				li.classList.toggle( 'active', isHashMatch || ( !hash && isParamMatch ) );
			} );

			if ( target ) {
				target.scrollIntoView( { behavior: 'smooth', block: 'start' } );
			}
		}

		navLinks.forEach( link => {
			const anchor = link.querySelector( 'a' );
			if ( anchor ) {
				anchor.addEventListener( 'click', function ( e ) {
					const anchorHref = this.getAttribute( 'href' );
					if ( anchorHref && anchorHref.startsWith( '#' ) ) {
						e.preventDefault();
						handleNavClick( anchorHref, this );
					}
				} );
			}
		} );

		const urlParams = new URLSearchParams( window.location.search );
		const deliveryId = urlParams.get( 'delivery_method_id' );
		if ( deliveryId ) {
			const input = [ ...deliveryFilterInputs ].find( inp => inp.dataset.ids.split('!')[0] === deliveryId );
			if ( input ) {
				input.checked = true;
				const sectionId = input.closest( '.filter-panel' )?.id || 'listing';
				smoothScrollTo( `#${sectionId}` );
			}
		}

		// Initial state
		updateStickyTop();
		setScrollMargin();
		updatePromoBannerTop();
		setActiveOnLoad( window.location.hash );


		// Recalculate on load and resize
		[ 'load', 'resize' ].forEach( event =>
			window.addEventListener( event, () => {
				updateStickyTop();
				setScrollMargin();
				updatePromoBannerTop();
			} )
		);

		// Recalculate when promo banner closes
		if ( promoBannerCloseBtn ) {
			promoBannerCloseBtn.addEventListener( 'click', () => {
				promoBanner.style.display = 'none';
				updateStickyTop();
				setScrollMargin();
			} );
		}
	} );
} )();
